/* eslint-disable jsx-a11y/alt-text */
import React, { } from "react";
import Menu from '../funtComponents/menu';
//MATERIAL
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import logo from '../../images/megac.png';


//

//


const Drwaer = (props) => {

    const drawerWidth = 240;

    //


    return (
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',

                    },
                }}
                variant="permanent"
                anchor="left"
            >
                <div style={{ height: '100%', backgroundColor: '#454545' }}>
                    <Toolbar style={{ backgroundColor: '#fff' }}>
                        <img src={logo} style={{ width: 170, height: 35, alignSelf: 'center' }} />
                    </Toolbar>
                    <Divider />
                    <Menu />
                </div>
            </Drawer>
    );
};

export default Drwaer;
